import { z } from "zod";
import { fraquezaDaSenha, senhaNovaSchema } from "./senha";

export const signupSchema = z
  .object({
    email: z.string().trim().toLowerCase().email("E-mail invalido"),
    password: senhaNovaSchema,
    /** Token do convite de equipe quando o cadastro é feito pela página do convite — só esse
     *  convite (e os irmãos do mesmo envio) é aceito no cadastro. */
    conviteToken: z.string().trim().min(1).max(200).optional(),
    /** Marcou "Concordo com os Termos de Uso e a Política de Privacidade" (vale a versão vigente). */
    aceiteDosDocumentos: z.boolean().optional(),
  })
  .superRefine((v, ctx) => {
    // Só o que depende do e-mail; o resto o senhaNovaSchema já apontou.
    if (fraquezaDaSenha(v.password)) return;
    const motivo = fraquezaDaSenha(v.password, { email: v.email });
    if (motivo) ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["password"], message: motivo });
  });

export type SignupInput = z.infer<typeof signupSchema>;
